<template>

  <el-row>

    <el-col :span="24">

      <data-table :title="type + ' Actions'"
         :table-ref="tableRef"
         :url="'/actions/site/' + rowData.id + '/' + type.toLowerCase() + '/'"
         :fields="fields"
         :site-id="rowData.id"
         search-placeholder="Type, Priority, Status..."
         :add-action="isActive ? action : null"
         :add-props="isActive ? addProps : null"
         :options="options"
         detail-component="action-detail-row">

         <template slot="action-type" slot-scope="props">

           <div v-if="props.rowData.actionType">
             <b>{{props.rowData.actionType}}</b>
           </div>

           <el-button
              ref="act"
              v-if="props.rowData.actionType==='ACTIVE'"
              size="small"
              type="primary"
              :disable="!isManager('project|management')"
              @click="siteActive(props.rowData.id, $event)"
              icon="fa fa-check-circle">&nbsp;Make Active
           </el-button>

           <el-button
              ref="dis"
              v-if="props.rowData.actionType==='DISMANTLE'"
              size="small"
              type="danger"
              :disable="!isManager('project|management')"
              @click="siteDismantle(props.rowData.id, $event)"
              icon="fa fa-trash-alt">&nbsp;Set Dismantled
            </el-button>

          <ticket-action
            ref="tic"
            v-if="props.rowData.actionType==='COMPLAINT'"
            :showText="true"
            :row-data="props.rowData"
            size="small"
           :site-id="siteId"
           :org-id="props.rowData.organisation_id"
           :ticket-id="props.rowData.ticket_id" />

         </template>



         <template slot="delete" slot-scope="props">
           <el-row :gutter="12">
             <el-col :span="16" align="left">
               <contacts-popover :row-data="rowData" />
             </el-col>

             <el-col :span="4" align="right" v-if="isManager('management')">
               <el-button class="hidden-sm-and-down" icon="fa fa-trash-alt" @click="deleteEntry(props.rowData)" circle size="small" type="danger"></el-button>
             </el-col>
           </el-row>
         </template>

       </data-table>

     </el-col>
  </el-row>

</template>


<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

import {settings} from '@/components/Data'

import SiteMixins from '@/mixins/SiteMixins'

import ContactsPopover from '@/components/atoms/ContactsPopover'
import GeneralAction from '@/components/actions/GeneralAction'

import RequestAction from '@/components/actions/RequestAction.vue'
import ProgressWorkflowAction from '@/components/actions/ProgressWorkflowAction'

import RenewalAction from '@/components/actions/RenewalAction'
import TicketAction from '@/components/actions/TicketAction'


import ActionDetails from '@/components/actions/ActionDetails.vue'

Vue.use(VueEvents)

Vue.component('action-detail-row', ActionDetails)

export default {
  mixins: [SiteMixins],

  name: 'ActionsTable',

  components: {
    ContactsPopover,
    ActionDetails,
    GeneralAction,
    RenewalAction,
    RequestAction,
    ProgressWorkflowAction,
    TicketAction
  },


  props: {

    type: {
      type: String,
      required: true
    },

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },



  methods: {

    actionDeleted () {
      this.actionId = null
      this.refreshStats()
    },

    selfDelete () {

      if (this.actionId) {
        this.deleteItem(this, this.actionId, '/actions', null, this.actionDeleted, false, this.tableRef)
      }
    },

    successActive () {
      this.$message({
        type: 'success',
        message: 'Status changed to Active'
      })

      this.selfDelete()
    },

    makeActive (actionId) {
      this.actionId = actionId

      this.siteData.status = this.activeSite()
      this.siteData.active = new Date()
      this.siteDate.dismantled = null
      this.saveSite(this.siteData, 'Site Active', this.successActive)
    },

    successDismantled () {
      this.$message({
        type: 'success',
        message: 'Status changed to Dismantled'
      })

      this.selfDelete()
    },

    makeDismantled (actionId) {
      this.actionId = actionId

      this.siteData.status = this.dismantledSite()
      this.siteData.dismantled = new Date()
      this.saveSite(this.siteData, 'Site Dismantled', this.successDismantled)
    },


    siteActive (actionId) {
      this.$confirm('This will set the site to <b>"Active"</b>. Continue?', 'Warning', {
        confirmButtonText: 'Active',
        cancelButtonText: 'Cancel',
        center: true,
        dangerouslyUseHTMLString: true,
        type: 'primary'
      }).then(() => {
        this.makeActive(actionId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Active change cancelled'
        })
      })
    },


    siteDismantle (actionId) {
      this.$confirm('This will set the site to <b>"Dismantled"</b>. Continue?', 'Warning', {
        confirmButtonText: 'Dismantle',
        cancelButtonText: 'Cancel',
        center: true,
        dangerouslyUseHTMLString: true,
        type: 'danger'
      }).then(() => {
        this.makeDismantled(actionId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Dismantle change cancelled'
        })
      })
    },

    deleteEntry (row) {
      this.deleteItem(this, row.id, '/actions', row.actionType + ' ' + row.summary, this.onDelete, true, this.tableRef)
    },

    onDelete (response) {
      this.$emit('update-stats')
    }

  },



  data () {

    return {
      tableRef: (this.type ? this.type.toLowerCase() + '-' : '') + 'action-table',
      isActive: (this.type ? this.type.toLowerCase() !== 'rejected' && this.type.toLowerCase() !== 'closed' : false),
      permitLabel: settings.permitLabel,
      actionId: null,
      siteData: this.rowData,
      siteId: this.rowData.siteName ? this.rowData.id : this.rowData.site_id,

      action: GeneralAction,
      addProps: {
        rowData: this.rowData,
        siteData: this.rowData.site,
        tableRef: (this.type ? this.type.toLowerCase() + '-' : '') + 'action-table',
        siteId: this.rowData.site_id ? this.rowData.site_id : this.rowData.id,
        editMode: this.editMode,
        readOnly: this.readOnly
      },

      options: {
        siteId: this.rowData.siteName ? this.rowData.id : this.rowData.site_id,
        siteData: this.rowData.siteName ? this.rowData : this.rowData.site
      },

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: '__slot:action-type',
          title: 'Type'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'priority',
          title: 'Priority',
          sortField: 'priority',
          callback: this.formatPriority,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'organisation.shortName',
          title: 'Company',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'targetDate',
          title: 'Target Date',
          callback: 'formatDate|DD MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__slot:delete',
          title: ''
        }
      ]
    }

  }
}

</script>
